export { default, aggPromiseCache } from './fetch-v2';
